var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.membershipdata != '')?_c('v-row',{staticClass:"pb-7",staticStyle:{"padding-left":"30px","padding-right":"30px"}},[_c('iframe',{attrs:{"src":_vm.membershipdata}})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }